module.exports = __webpack_public_path__ + "img/star9.de2c021d.png";